Namespace 'Common.Dashboard.Filters'

class Common.Dashboard.Filters.CompositeFilter

  constructor: ({json, defaultFilters, filtersFactory}) ->
    @filtersFactory = filtersFactory
    @setFilters(json)
    @defaultFilters = defaultFilters

  _parse: (json) ->
    @_parseFilter(filterType, contents) for filterType, contents of json

  _parseFilter: (filterType, contents) ->
    @filtersFactory.getFilter(filterType, contents)

  getFilters: ->
    @filters

  toJSON: ->
    _.assign({}, (filter.toJSON() for filter in @filters)...)

  addFilter: (newFilter) ->
    filterWithType = @filterWithType(newFilter.getFilterType())
    if filterWithType
      filterWithType.setValues(newFilter.values)
    else
      @filters.push newFilter

  removeFilter: (filterToRemove) ->
    return unless filterToRemove.isRemovable()
    @filters = _.reject(@filters, (filter) -> filter.getFilterType() == filterToRemove.getFilterType())

  removeValue: (filter, value) ->
    ownFilter = @filterWithType(filter.getFilterType())
    return unless ownFilter.isRemovable()
    ownFilter.removeValue value
    @removeFilter ownFilter unless ownFilter.hasValues()

  removeAllFilters: ->
    filtersCopy = [@filters...]
    @removeFilter(filter) for filter in filtersCopy

  filterWithType: (type) ->
    _.find(@filters, (filter) -> filter.getFilterType() == type)

  nonReappliableFilters: ->
    filter for filter in @filters when not filter.isReappliable()

  onlyHasDefaultFilter: =>
    filter_types = @filters.map((filter) -> filter.getFilterType())
    return _.isEqual(filter_types, @defaultFilters.map((filter) -> (filter).FILTER_TYPE))

  setFilters: (json) =>
    @filters = @_parse json
